import { makeAutoObservable } from "mobx";
import { ConfigApi } from "../../api/base/ConfigApi";
import ApplicationApi from "../../api/ApplicationApi";

class ApiStore {
  api!: ApplicationApi;

  configApi: ConfigApi = {} as ConfigApi;
  constructor(configApi: ConfigApi) {
    makeAutoObservable(this);
    this.configApi = configApi;
    this.api = new ApplicationApi(configApi);
  }
}
export default ApiStore;